import { requests } from 'api';
import { getFirstSegment } from 'utils/urls';
import { Reason, CreateServiceCallCommand, FindServiceCallByIdQuery, ServiceCall, FindServiceCallByContractQuery } from './types';

const apiBaseUrl = `/${getFirstSegment()}/api/servicecalls`;

export const ServiceCallsApi = {
  getReasons: () => requests.get<Reason[]>(`${apiBaseUrl}/reasons`),
  get: (id: string) => requests.get<ServiceCall>(`${apiBaseUrl}/${id}`),
  getAttachment: (fileName: string) => requests.get<File>(`${apiBaseUrl}/attachments/${fileName}`),
  deleteAttachment: (serviceCallId: string, noteId: number, attachmentId: number) => requests.delete(`${apiBaseUrl}/${serviceCallId}/notes/${noteId}/attachments/${attachmentId}`),
  findById: (query: FindServiceCallByIdQuery) => requests.post<string>(`${apiBaseUrl}/findById`, query),
  findByContract: (query: FindServiceCallByContractQuery) => requests.post<ServiceCall[]>(`${apiBaseUrl}/findByContract`, query),
  addNote: (serviceCallId: string, note: string, attachments: File[]) => {
    const formData = new FormData();

    formData.append('note', note);

    attachments.forEach(attachment =>
      formData.append('attachments', attachment)
    );

    return requests.post(`${apiBaseUrl}/${serviceCallId}/notes`, formData);
  },
  create: (serviceCall: CreateServiceCallCommand, attachments: File[]) => {
    const formData = new FormData();

    formData.append('contractNumber', serviceCall.contractNumber);
    formData.append('clientNumber', `${serviceCall.clientNumber}`);
    formData.append('reasonId', `${serviceCall.reasonId}`);
    formData.append('note', serviceCall.note);
    formData.append('firstName', serviceCall.contactInformation.firstName);
    formData.append('lastName', serviceCall.contactInformation.lastName);
    formData.append('email', serviceCall.contactInformation.email);
    formData.append('phoneNumber', serviceCall.contactInformation.phoneNumber);

    if (serviceCall.productId)
      formData.append('productId', `${serviceCall.productId}`);
    else {
      formData.append('productName', `${serviceCall.productName}`);
      formData.append('productSku', `${serviceCall.productSku}`);
    }

    attachments.forEach(attachment =>
      formData.append('attachments', attachment)
    );

    return requests.post(apiBaseUrl, formData);
  }
};